<template>
  <div></div>
</template>

<script>
export default {
  name: 'Basic'
}
</script>

<style scoped>

</style>
